export const FETCH_EARLY_COD_CHARGES_REQUEST = "FETCH_EARLY_COD_CHARGES_REQUEST";
export const FETCH_EARLY_COD_CHARGES_SUCCESS = "FETCH_EARLY_COD_CHARGES_SUCCESS";
export const FETCH_EARLY_COD_CHARGES_FAILURE = "FETCH_EARLY_COD_CHARGES_FAILURE";
export const FETCH_EARLY_COD_CHARGES_RESET = "FETCH_EARLY_COD_CHARGES_RESET";
export const fetchEarlyCodChargesRequest = (payload) => ({
    type: FETCH_EARLY_COD_CHARGES_REQUEST,
    payload,
});
export const fetchEarlyCodChargesSuccess = (payload) => ({
    type: FETCH_EARLY_COD_CHARGES_SUCCESS,
    payload,
});
export const fetchEarlyCodChargesFailure = (payload) => ({
    type: FETCH_EARLY_COD_CHARGES_FAILURE,
    payload,
});
export const fetchEarlyCodChargesReset = () => ({
    type: FETCH_EARLY_COD_CHARGES_RESET,
});
